import { motion } from "framer-motion";
import { testimonials } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="relative bg-forest-900 text-ivory py-24 md:py-40"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 mb-14 md:mb-20 gap-8">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="h-px w-10 bg-lime" />
                            <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">
                                In their words
                            </span>
                        </div>
                        <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-[14ch]">
                            Residents, architects, and one editor.
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-10% 0px" }}
                            transition={{ duration: 0.95, ease: EASE, delay: i * 0.06 }}
                            data-testid={`testimonial-${i}`}
                            className="relative border-t border-white/15 pt-10 pr-4"
                        >
                            <div className="absolute -top-6 left-0 font-serif-display text-[6rem] leading-none text-lime/40 italic">
                                “
                            </div>
                            <blockquote className="font-serif-display text-2xl md:text-[1.9rem] leading-snug tracking-tight text-ivory">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-8 flex items-center justify-between">
                                <div>
                                    <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/70">
                                        {t.author}
                                    </div>
                                    <div className="text-ivory/45 text-sm mt-1">{t.project}</div>
                                </div>
                                <div className="font-serif-display italic text-lime">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
